<template>
  <div class="wrraper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <transition-group name="fadeInUp" mode="in-out">
      <!-- Start Main Loader -->
      <!-- <MainLoader key="loader" v-if="loading" /> -->
      <!-- End Main Loader -->

      <div key="main" class="orders-list">
        <main-filter
          :withSearch="false"
          :orderId="true"
          :customerNumber="true"
          :branchNumber="true"
          :branchName="true"
          :delievery_type="true"
          :dateStart="true"
          :dateEnd="true"
          col="3"
        />
        <!-- Start Statistics Card-->
        <!-- <div class="row mb-5">
          <div class="wrraper">
            <stats-card
              :title="$t('ordersNum')"
              :number="statisticsItem.number"
            ></stats-card>
          </div>
        </div> -->
        <!-- End Statistics Card-->

        <!-- Start Main Section -->
        <main>
          <v-data-table
            class="elevation-1 thumb diff_table"
            :headers="headers"
            :items="rows"
            :search="search"
            :custom-filter="helper_filterSearch"
            :loading="loading"
            :loading-text="$t('table.loadingData')"
            item-key="id"
            :items-per-page="paginations.items_per_page"
            hide-default-footer
            :item-class="itemRowBackground"
          >
            <!-- ================== You Can use any slots you want ================== -->
            <!-- Select no data State -->
            <template v-slot:no-data>
              {{ $t("table.noData") }}
            </template>

            <template v-slot:[`item.index`]="{ index }">
              {{ index + 1 }}
            </template>
            <template v-slot:[`item.order_num`]="{ item }">
              <div class="order-cell">
                <strong>#{{ item.order_num }}</strong>
                <small v-if="item.shipping_provider">{{ shippingLabel(item.shipping_provider) }}</small>
              </div>
            </template>
            <template v-slot:[`item.branch.full_name`]="{ item }">
              <div v-if="item.branch" class="client-cell">
                <strong>{{ item.branch.full_name }}</strong>
                <small v-if="item.branch.code">{{ item.branch.code }}</small>
              </div>
            </template>
            <template v-slot:[`item.client`]="{ item }">
              <div v-if="item.client" class="client-cell">
                <strong>{{ item.client.full_name }}</strong>
                <small>{{ item.client.phone_complete_form }}</small>
              </div>
              <span v-else>{{ $t("notFound") }}</span>
            </template>

            <template v-slot:[`item.is_payment`]="{ item }">
              <span class="pill" :class="item.is_payment === 'paid' ? 'is-ok' : 'is-wait'">
                {{ item.is_payment_trans }}
              </span>
            </template>
            <template v-slot:[`item.order_type`]="{ item }">
              <span class="status">
                {{
                  item.order_type == "normal" ? $t("ordinary") : $t("sechudle")
                }}
              </span>
            </template>
            <template v-slot:[`item.address`]="{ item }">
              <span v-if="addressText(item)" class="address-cell">{{ addressText(item) }}</span>
              <span v-else>{{ $t("notFound") }}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <span class="pill" :class="statusTone(item.status)">
                {{ item.status_trans }}
              </span>
              <div v-if="item.have_item_out_of_stock" class="stock-note">
                {{ $t("have_item_out_of_stock") }}
              </div>
            </template>
            <template v-slot:[`item.order_details.delivery_date`]="{ item }">
              <span>
                {{
                  item.order_details.delivery_date
                    ? item.order_details.delivery_date
                    : $t("notFound")
                }}
              </span>
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              <div v-if="item.updated_at" class="when">
                <span>{{ item.updated_at.slice(0, 10) }}</span>
                <small>{{ item.updated_at.slice(11) }}</small>
              </div>
            </template>
            <template v-slot:[`item.scheduled_at`]="{ item }">
              <span v-if="item.scheduled_at">
                {{ item.scheduled_at }}
              </span>
              <p v-if="item.times">
                {{
                  $i18n.locale == "ar" ? item.times.day_trans : item.times.day
                }}
              </p>
              <p dir="ltr" v-if="item.times">
                {{ item.times.from + " to " + item.times.to }}
              </p>
            </template>
            <template v-slot:[`item.order_details.delivery_timing`]="{ item }">
              <span>
                {{
                  item.order_details.delivery_date
                    ? item.order_details.delivery_date
                    : $t("notFound")
                }}
              </span>
            </template>
            <template v-slot:[`item.to`]="{ item }">
              <router-link :to="`/users/show/${item.to.id}`">
                {{ item.to.fullname }}
              </router-link>
            </template>
            <template v-slot:[`item.is_pickup_from_branch`]="{ item }">
              <span class="pill" :class="item.is_pickup_from_branch ? 'is-wait' : 'is-ok'">
                {{
                  item.is_pickup_from_branch
                    ? $t("pickup_from_branch")
                    : $t("delivery_to_home")
                }}
              </span>
            </template>
            <template v-slot:[`item.price_details.total_price`]="{ item }">
              <span v-if="item.price_details" class="money">
                {{ item.price_details.total_price }} {{ item.price_details.currency }}
              </span>
            </template>
            <!-- End:: Users Routes -->

            <!-- Start:: Report Reason Modal Button -->
            <template v-slot:[`item.report_reason`]="{ item }">
              <v-icon
                class="show"
                small
                @click="controlReportReasonModalModal(item.report_reason)"
                v-if="item.report_reason"
              >
                fal fa-eye
              </v-icon>

              <span v-else>_</span>
            </template>
            <!-- End:: Report Reason Modal Button -->

            <!-- Select actions-->
            <template v-slot:[`item.actions`]="{ item }">
              <div class="_actions">
                <v-icon class="show" small @click="showItem(item)">
                  fal fa-eye
                </v-icon>
                <!-- <v-icon class="edit" small @click="editItem(item)">
                  fal fa-edit
                </v-icon> -->
                <!-- <v-icon class="delete" small @click="deleteItem(item)">
                  fal fa-trash
                </v-icon> -->
              </div>
            </template>

            <!-- ======================== Start Top Section ======================== -->
            <template v-slot:top>
              <h3 class="title table-title">
                {{ $t("titles.ordersNum") }} {{ rows.length }}
              </h3>
              <!-- Delete dialog -->
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5 justify-center">
                    {{ $t("table.deletedialog.areYouSure") }}
                  </v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#1B5E20" @click="deleteItemConfirm">
                      {{ $t("table.deletedialog.ok") }}
                    </v-btn>
                    <v-btn color="#F44336" @click="dialogDelete = false">
                      {{ $t("table.deletedialog.cancel") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <!-- Start:: Text Content Modal -->
              <TextContentModal
                @toggleModal="controlReportReasonModalModal"
                :modalIsActive="reportReasonModalIsOpen"
                :title="$t('reportReason')"
                :textContent="reportReasonToShow"
              />
              <!-- End:: Text Content Modal -->

              <section
                class="table-buttons d-inline-flex p-0"
                style="width: fit-content"
              >
                <div>
                  <div class="px-5 pt-3 frm-action d-flex flex-row gap-2">
                    <button
                      class="export btn"
                      :disabled="exportSheetLoading"
                      @click="exportOrdersSheet"
                    >
                      <span v-if="exportSheetLoading">{{ $t("table.loadingData") }}</span>
                      <span v-else
                        >Export <i class="fal fa-download"></i
                      ></span>
                    </button>
                  </div>
                </div>
              </section>
            </template>
            <!-- ======================== End Top Section ======================== -->
          </v-data-table>
        </main>
        <!-- End Main Section -->

        <!-- Start Pagination -->
        <template>
          <div
            class="pagination_container text-center mb-5 d-flex justify-content-end"
          >
            <v-pagination
              v-model.number="paginations.current_page"
              :length="paginations.last_page"
              :total-visible="7"
              @input="fetchData($event)"
            ></v-pagination>
          </div>
        </template>
        <!-- End Pagination -->
      </div>
    </transition-group>
    <base-model
      @closeModel="model_1.show_model = false"
      :show="model_1.show_model"
    >
      <div class="image">
        <img
          v-if="model_1.model_img_src"
          :src="model_1.model_img_src"
          alt="..."
        />
      </div>
    </base-model>
    <v-dialog v-model="model_2.show_model" width="500">
      <v-card>
        <v-card-text class="text-center">
          {{ model_2.text }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog class="" v-model="reject_reason_model" width="500">
      <v-card>
        <v-card-title> {{ $t("messages.orderCancel") }} </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="reject_reason"
            class="w-100 p-5"
            :placeholder="$t('forms.labels.rejectReason')"
            style="
              border: 1px solid var(--mainColor-2);
              border-radius: 10px;
              padding: 10px !important;
            "
          >
          </v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#F44336"
            @click="changeStatus('admin_reject', reject_reason_item_id)"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-btn color="#1B5E20" @click="reject_reason_model = false">
            {{ $t("back") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// Start:: Importing Modals
import TextContentModal from "@/components/Modals/TextContentModal.vue";

// End:: Importing Modals

export default {
  name: "UsersReports",

  components: {
    TextContentModal,
  },

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.orders.title"),
          disabled: true,
          href: "",
        },
        // {
        //   text: this.$t("breadcrumb.transaction.products"),
        //   disabled: true,
        //   href: "",
        // },
      ],

      // ========== Statistics
      statisticsItem: {},

      // ========== Top Section
      search: "",

      // ========== dialog Status
      dialogDelete: false,
      itemtoDelete: null,
      reportReasonModalIsOpen: false,
      reportReasonToShow: null,
      model_1: {
        show_model: false,
        model_img_src: "",
        model_text: "",
      },
      model_2: {
        show_model: false,
        text: "",
      },
      // ========== Your Data
      rows: [], // injected in created

      // ========== pagination
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 20,
      },

      // ========== Loading
      loading: false,
      exportSheetLoading: false,
      // reject reason
      reject_reason_model: false,
      reject_reason: null,
      reject_reason_item_id: null,
    };
  },

  computed: {
    ...mapGetters({
      lang: "lang_module/lang",
    }),

    headers() {
      this.lang;
      return [
        { text: "#", align: "center", value: "index", sortable: false, width: "56" },
        { text: this.$t("titles.orderNumber"), align: "start", value: "order_num", sortable: false },
        { text: this.$t("labels.client"), align: "start", value: "client", sortable: false },
        { text: this.$t("titles.shippingAddress"), align: "start", value: "address", sortable: false },
        { text: this.$t("branch"), align: "start", value: "branch.full_name", sortable: false },
        { text: this.$t("titles.distance"), align: "center", value: "distance", sortable: false },
        { text: this.$t("titles.total"), align: "center", value: "price_details.total_price", sortable: false },
        { text: this.$t("forms.labels.status"), align: "center", value: "status", sortable: false },
        { text: this.$t("titles.date"), align: "center", value: "scheduled_at", sortable: false },
        { text: this.$t("titles.updatedAt"), align: "start", value: "updated_at", sortable: false },
        { text: this.$t("titles.payType"), align: "center", value: "is_payment", sortable: false },
        { text: this.$t("delviery_type"), align: "center", value: "is_pickup_from_branch", sortable: false },
        { text: this.$t("workTime.table.actions"), align: "center", value: "actions", sortable: false },
      ];
    },
    orderStatusItems() {
      return [
        {
          label: this.$t("ordersStatus.watingAdmin"),
          name: "pending",
        },
        {
          label: this.$t("ordersStatus.adminAccept"),
          name: "store_accept",
        },
        {
          label: this.$t("ordersStatus.adminCancel"),
          name: "store_reject",
        },
        {
          label: this.$t("ordersStatus.clientCancel"),
          name: "client_cancel",
        },
        {
          label: this.$t("ordersStatus.shipping"),
          name: "admin_shipping",
        },
        {
          label: this.$t("ordersStatus.deliverd"),
          name: "admin_delivered",
        },
        {
          label: this.$t("ordersStatus.clientFinished"),
          name: "client_finished",
        },
      ];
    },
  },

  watch: {
    $route() {
      this.paginations.current_page = +(this.$route.query.page || 1);
      this.setRows();
    },
  },

  methods: {
    addressText(item) {
      const sources = [item && item.address, item && item.address_data];
      for (const address of sources) {
        if (!address || Array.isArray(address)) continue;
        const text = address.place_description || address.location_description;
        if (text) return text;
      }
      return "";
    },
    statusTone(status) {
      if (["delivered", "arrived"].includes(status)) return "is-ok";
      if (
        ["admin_cancel", "client_cancel", "admin_reject", "driver_cancel", "admin_cancel_after_delivered"].includes(status)
      ) {
        return "is-bad";
      }
      if (["on_the_way", "progress", "order_placed"].includes(status)) return "is-go";
      return "is-wait";
    },
    shippingLabel(provider) {
      const key = "forms.labels." + provider;
      return this.$te(key) ? this.$t(key) : provider;
    },

    async exportOrdersSheet() {
      const stamp = new Date().toISOString().slice(0, 10);
      await this.downloadExcelExport(
        "order/export-sheet",
        `orders_${stamp}.xlsx`,
        "exportSheetLoading"
      );
    },

    async downloadExcelExport(url, filename, loadingKey, withFilters = false) {
      this[loadingKey] = true;
      try {
        const params = withFilters ? this.buildFilterParams({ filtered: 1 }) : {};
        const response = await this.$axios.get(url, {
          params,
          responseType: "blob",
        });

        const contentType = response.headers["content-type"] || "";
        if (contentType.includes("application/json")) {
          const text = await response.data.text();
          const payload = JSON.parse(text);
          throw new Error(payload.message || this.$t("table.noData"));
        }

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);

        const exportedTotal = response.headers["x-export-total"];
        if (exportedTotal) {
          this.$iziToast.success({
            timeout: 2500,
            message: `${this.$t("titles.orders")}: ${exportedTotal}`,
            position: "bottomRight",
          });
        }
      } catch (err) {
        let message = this.$t("table.noData");
        if (err.response?.data instanceof Blob) {
          try {
            const text = await err.response.data.text();
            const payload = JSON.parse(text);
            message = payload.message || message;
          } catch (parseError) {
            // keep default message
          }
        } else if (err.response?.data?.message) {
          message = err.response.data.message;
        } else if (err.message) {
          message = err.message;
        }

        this.$iziToast.error({
          timeout: 2500,
          message,
          position: "bottomRight",
        });
      } finally {
        this[loadingKey] = false;
      }
    },

    buildFilterParams(extra = {}) {
      const params = { ...extra };
      const query = this.$route.query;
      const map = {
        order_id: query.order_id,
        customer_number: query.customer_number,
        branch_name: query.branch_name,
        branch_number: query.branch_number,
        from: query.dateStart,
        to: query.dateEnd,
      };

      Object.entries(map).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params[key] = value;
        }
      });

      if (
        query.is_pickup !== undefined &&
        query.is_pickup !== null &&
        query.is_pickup !== ""
      ) {
        params.is_pickup = query.is_pickup;
      }

      return params;
    },

    showAddress(address) {
      this.model_2.show_model = true;
      this.model_2.text = address.location_description;
    },
    // ===== Search Method =====
    filterClick(word) {
      if (!this.loading) {
        this.search = word;
        this.helper_filterSearch();
      }
    },
    openRejectModel(id) {
      this.reject_reason_item_id = id;
      this.reject_reason_model = true;
    },
    changeStatus(currStatus, id) {
      this.btnIsLoading = true;
      let submit_data = new FormData();
      let keepGoing = true;
      if (currStatus == "admin_reject") {
        if (!this.reject_reason) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.reject_reason"),
            position: "bottomRight",
          });
          keepGoing = false;
        }

        submit_data.append("reject_reason", this.reject_reason);
      }
      if (!keepGoing) {
        return;
      }
      submit_data.append("status", currStatus);
      submit_data.append("_method", "PUT");
      this.$axios({
        method: "POST",
        url: `order/${id}/change_status`,
        data: submit_data,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          // this.$router.push({ path: "/transactions/all-transactions" });
          this.btnIsLoading = false;
          this.reject_reason_model = false;
          this.setRows();
        })
        .catch((err) => {
          if (err.response.data.status == "fail") {
            this.$iziToast.error({
              timeout: 2000,
              message: err.response.data.message,
              position: "bottomRight",
            });
          }

          this.setRows();
          this.btnIsLoading = false;
        });
    },
    show_model_1(e) {
      this.model_1.model_img_src = e;
      this.model_1.show_model = true;
    },
    orderStatusList(status) {
      if (status == "pending") {
        return [
          {
            text: this.$t("aceept"),
            value: "order_placed",
          },
          { text: this.$t("reject"), value: "admin_reject" },
        ];
      } else if (status == "order_placed") {
        return [
          {
            text: this.$t("deliverd"),
            value: "delivered",
          },
          { text: this.$t("cancel"), value: "admin_cancel" },
        ];
      }
    },
    // ===== Toggle Report Reason Modal =====
    controlReportReasonModalModal(selectedReportReason) {
      this.reportReasonToShow = selectedReportReason;
      this.reportReasonModalIsOpen = !this.reportReasonModalIsOpen;
    },

    // ==================== Start CRUD ====================
    addItem() {
      this.$router.push({ path: "/orders/add" });
    },
    showItem(item) {
      this.$router.push({ path: "/orders/show/" + item.id });
    },
    editItem(item) {
      this.$router.push({ path: "/orders/edit/" + item.id });
    },
    // ===== Delete
    deleteItem(item) {
      this.dialogDelete = true;
      this.itemtoDelete = item;
    },
    deleteItemConfirm() {
      this.$axios({
        method: "DELETE",
        url: `order/${this.itemtoDelete.id}`,
      })
        .then(() => {
          this.rows = this.rows.filter((item) => {
            return item.id != this.itemtoDelete.id;
          });
          this.dialogDelete = false;
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("deleteSuccess"),
            position: "bottomRight",
          });
        })
        .catch((err) => {
          this.dialogDelete = false;
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
        });
    },
    // ==================== End CRUD ====================
    itemRowBackground(item) {
      return item.status == "progress" ? "in_progress" : item.status;
      // console.log(item);
    },

    // Set Rows
    setRows() {
      this.loading = true;
      this.$axios({
        method: "GET",
        url: "order",
        params: this.buildFilterParams({
          page: this.paginations.current_page,
        }),
      })
        .then((res) => {
          this.paginations.last_page = res.data.meta.last_page;
          this.paginations.items_per_page = res.data.meta.per_page;

          this.rows = res.data.data;

          this.statisticsItem.number = res.data.meta.total;

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchData(e) {
      this.$router
        .push({
          query: Object.assign({}, this.$route.query, {
            page: e,
          }),
        })
        .catch(() => {});

      this.setRows();
    },
  },
  created() {
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setRows();
  },

  // ======= hooks
};
</script>

<style lang="scss">
.v-text-field__details {
  display: none !important;
}
.v-input__slot {
  margin-bottom: 0 !important;
}
.status_btn {
  i {
    padding: 0.5rem;
    color: white;
    font-size: 1.2rem;
    border-radius: 50%;
    margin-bottom: 5px;
    transition: all 0.3s;
  }
  &.accept {
    i {
      background: #1b5e20;
    }
  }
  &.reject {
    i {
      padding: 0.5rem 0.75rem;
      background: #f44336;
    }
  }
  &:hover {
    i {
      scale: 1.2;
      opacity: 0.8;
    }
  }
}
.orders-list {
  tr.admin_reject,
  tr.client_cancel,
  tr.admin_cancel,
  tr.driver_cancel,
  tr.admin_cancel_after_delivered,
  tr.client_reject,
  tr.in_progress,
  tr.progress,
  tr.pending,
  tr.order_placed,
  tr.delivered,
  tr.on_the_way,
  tr.arrived {
    background: #fff !important;

    td {
      color: #142116 !important;
      font-weight: 600;
    }
  }

  .table-title {
    margin: 0;
    padding: 4px 4px 12px;
    font-size: 18px;
    font-weight: 800;
    color: #142116;
  }

  .export.btn {
    background: #e7f6ee;
    border: 0;
    color: #1b5e20;
    border-radius: 10px;
    height: 36px;
    padding: 0 14px;
    font-weight: 700;
  }

    .v-data-table.diff_table {
      border: 1px solid #e4eadf;
      border-radius: 16px !important;
      box-shadow: 0 6px 16px rgba(20, 33, 22, 0.04) !important;
      overflow: hidden;
      background: #fff;

      .v-data-table__wrapper {
        overflow-x: auto;
      }

      table {
        border-collapse: collapse !important;
        border-spacing: 0 !important;
      }

      .v-data-table-header {
        background: #f7f8f6 !important;
        border-radius: 0 !important;
      }

      .v-data-table-header tr th {
        background: #f7f8f6 !important;
        color: #4b5563 !important;
        font-size: 12px !important;
        font-weight: 700 !important;
        height: 44px !important;
        white-space: nowrap;
        border-bottom: 1px solid #e4eadf !important;
      }

    .v-data-table-header__icon {
      color: #6b7280 !important;
    }

    tbody tr {
      transform: none !important;
      box-shadow: none !important;
      background: #fff;
    }

    tbody td {
      height: 56px;
      border-bottom: 1px solid #f0f2ee !important;
      font-size: 13px;
      font-weight: 600;
      color: #142116 !important;
      white-space: nowrap;
    }

    tbody tr:hover {
      transform: none !important;
      background: #f7fbf7 !important;

      td {
        color: #142116 !important;
      }
    }
  }

  .when {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.35;
    white-space: nowrap;

    small {
      color: #6b7280;
      font-weight: 700;
    }
  }

  .order-cell,
  .client-cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    text-align: start;

    strong {
      color: #142116;
      font-weight: 800;
    }

    small {
      color: #6b7280;
      font-weight: 600;
    }
  }

  .address-cell {
    display: block;
    max-width: 220px;
    text-align: start;
    line-height: 1.4;
    white-space: normal;
  }

  .money {
    font-weight: 800;
    color: #1b5e20;
  }

  .pill {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 28px;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.3;
    white-space: normal;
  }

  .pill.is-ok {
    background: #e7f6ee;
    color: #1b5e20;
  }

  .pill.is-wait {
    background: #fff6e0;
    color: #8a6a00;
  }

  .pill.is-go {
    background: #e8f1fb;
    color: #1d4e89;
  }

  .pill.is-bad {
    background: #fdecea;
    color: #c62828;
  }

  .stock-note {
    margin-top: 4px;
    color: #c62828;
    font-size: 11px;
    font-weight: 700;
  }
}
</style>

